import { Box, Button, useTheme } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type ActionBarProps = {
  handleDiscard: () => void;
  handleSave: () => Promise<void>;
  loading: boolean;
  hidden?: boolean;
  submitDisabled?: boolean;
  backButtonHidden?: boolean;
};

export const ActionBar: FC<ActionBarProps> = ({
  handleDiscard,
  handleSave: _handleSave,
  loading: _loading,
  hidden,
  submitDisabled: _submitDisabled,
  backButtonHidden,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'sticky',
        bottom: 0,
        zIndex: 999,
        display: hidden ? 'none' : 'flex',
        justifyContent: 'space-between',
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2, 6),
        borderTop: `1px solid ${theme.palette.divider}`,
        boxShadow: '0px -3px 3px -2px rgba(0, 0, 0, 0.2)',
      }}
    >
      <Button
        variant="outlined"
        color="primary"
        sx={{
          borderRadius: 25,
          textTransform: 'none',
          fontWeight: 'bold',
          display: backButtonHidden ? 'none' : 'inline-flex',
        }}
        onClick={handleDiscard}
      >
        {t('patientProfile.buttons.back')}
      </Button>
      {backButtonHidden && <span />} {/* Placeholder to keep Save changes button on the right */}
      {/* <LoadingButton
        variant="contained"
        color="primary"
        loading={_loading}
        sx={{
          borderRadius: 25,
          textTransform: 'none',
          fontWeight: 'bold',
        }}
        disabled={_submitDisabled}
        onClick={_handleSave}
      >
        {t('patientProfile.buttons.saveChanges')}
      </LoadingButton> */}
    </Box>
  );
};
